import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctValue8 } from '../../../../Fct/generics';
import { FaCog } from 'react-icons/fa';
import { POOL_ADDRESSES } from '../constants';
export var SetUserEMode = createPlugin({
    protocol: 'AaveV3',
    type: 'ACTION',
    method: 'setUserEMode',
    supportedContracts: POOL_ADDRESSES,
    getParams: function (_a) {
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({ destination: 'aave_pool_v3' }),
                methodParams: {
                    categoryId: new FctValue8({ isPreview: true, icon: FaCog }),
                },
            },
            output: {},
        });
    },
});
